<template>
  <div id="sign-in-component" class="fs-5 border-start ps-3 h-100 border-secondary">
    <div class="text-danger fw-bold text-uppercase mb-0">
      {{ connect }}
    </div>
    <div class="d-flex flex-column w-100">
      <div class="mt-1 fs-6">
        <input type="email" aria-label="Username" :placeholder="placeHolderEmail" id="input-email" class="fs-6 pt-0 pb-0 w-100" v-model="username">
      </div>
      <div class="d-flex align-items-center mt-2">
        <input
          type="password"
          aria-label="Password"
          :placeholder="placeHolderPassword"
          id="input-password"
          class="fs-6 pt-0 pb-0"
          v-model="password"
          @keyup.enter="clickedSignIn">
        <button
          class="btn btn-danger text-white fs-6 border-0 ms-2 pt-1 pb-1 ps-2 pe-2 text-uppercase"
          type="submit"
          :disabled="signInStatus === SIGNED_IN_STATUS.RUNNING || (username === '' || password === '')"
          @click="clickedSignIn">
          <div v-if="signInStatus !== SIGNED_IN_STATUS.RUNNING">{{ buttonSignIn }}</div>
          <div v-else><font-awesome-icon icon="spinner" class="faa-spin animated" /></div> 
        </button>
      </div>
    </div>
    <h6
      class="text-decoration-underline text-white mt-1 fw-light clickable"
      @click="$router.push('/contact')">{{ NoAccount }}</h6>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import { Watch } from 'vue-property-decorator'

import { useLanguageStore } from "@/stores/language";
import { useUserStore } from "@/stores/user";
import { useCategoryStore } from "@/stores/category";
import { useCommonStore } from "@/stores/common";

import { TEXT_KEYS, SIGNED_IN_STATUS } from "@/constants";

@Options({
  components: {
  }
})
export default class Maintenance extends Vue {
  languageStore = useLanguageStore()
  userStore = useUserStore()
  categoryStore = useCategoryStore()
  commonStore = useCommonStore()

  username = ''
  password = ''

  SIGNED_IN_STATUS = SIGNED_IN_STATUS

  get connect() {
    return this.languageStore.text(TEXT_KEYS.SIGN_IN_CONNECT)
  }

  get NoAccount() {
    return this.languageStore.text(TEXT_KEYS.SIGN_IN_NO_ACCOUNT)
  }

  get buttonSignIn() {
    return this.languageStore.text(TEXT_KEYS.SIGN_IN_BUTTON_OK)
  }

  get placeHolderEmail() {
    return this.languageStore.text(TEXT_KEYS.SIGN_IN_PLACEHOLDER_EMAIL)
  }

  get placeHolderPassword() {
    return this.languageStore.text(TEXT_KEYS.SIGN_IN_PLACEHOLDER_PASSWORD)
  }

  get signInStatus() {
    return this.userStore.getSignInStatus
  }

  @Watch('signInStatus')
  onSignInStatusChanged(val: SIGNED_IN_STATUS, oldVal: SIGNED_IN_STATUS) {
    console.log("SignIn onSignInStatusChanged", val, oldVal)

    if (val === SIGNED_IN_STATUS.SIGNED_IN) {
      this.commonStore.setToastSuccessMessage(this.languageStore.text(TEXT_KEYS.TOAST_SIGNED_IN_SUCCESS))
      this.commonStore.setSignedInDate()
    } else if (val === SIGNED_IN_STATUS.FAILED) {
      this.commonStore.setToastDangerMessage(this.languageStore.text(TEXT_KEYS.TOAST_SIGNED_IN_FAILURE))
    }
  }

  public clickedSignIn() {
    console.log("clickedSignIn details", this.username, this.password)

    this.userStore.signIn(this.username.toLowerCase(), this.password)
  }
}
</script>

<style lang="stylus">
#sign-in-component
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  width: 12rem;

#input-password
  width: 100%

</style>
